





















import { defineComponent, ref, computed } from "@vue/composition-api";
import { Location } from "vue-router";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { handleRequestError } from "@/lib/handleRequestError";
import { $t } from "@/lib/i18nHelpers";
import { FormFields, FormValues } from "@/types";
import { EVENTS, ROLES } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseForm from "@/components/BaseForm";
import BasePage from "@/components/BasePage";
import InputPassword from "@/components/InputPassword";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "PageForgotPasswordSet",
  components: { BaseForm, InputPassword, BasePage, BaseButton, PageTitle },
  props: {
    token: { type: String, default: "" },
    role: { type: String, default: "" },
    changePassword: { type: Boolean, default: false },
  },
  setup(props, { root }) {
    const loading = ref(false);
    const showError = ref(false);
    const fieldError = ref("");

    const nextRoute = computed<Location>(() => {
      if (!props.changePassword) {
        return { name: props.role === ROLES.CREATOR ? "loginCreator" : "login" };
      }
      return {
        name: "more",
        query: { section: "account" },
      };
    });

    const values = ref<FormValues>({});
    const valid = ref(false);

    const fields = computed<FormFields>(() => [
      {
        name: "password",
        type: "password",
        placeholder: $t("Password"),
        autocomplete: "new-password",
        rules: props.role === ROLES.CREATOR ? ["required", "password_strong"] : ["required", "min:4"],
        validationMode: "aggressive",
      },
    ]);

    const submit = async () => {
      if (!valid.value) {
        return;
      }
      try {
        showError.value = false;
        fieldError.value = "";
        loading.value = true;
        providers.PasswordResetProvider.setReceiveErrors(false);
        await providers.PasswordResetProvider.change({
          data: { password: values.value.password, token: props.token },
        });

        root.$router.push(nextRoute.value);
        if (props.changePassword) {
          emitter.emit(EVENTS.NOTIFICATION_SHOW, { text: $t("Password has been changed") });
        }
      } catch (e) {
        handleRequestError(e, [
          {
            comparator: e => e.code === "PAGE_NOTFOUND" || e.code === "NOTFOUND",
            onSuccessCB: () => {
              fieldError.value = $t(
                "No active Olecams account found. Try again later. {br} If the problem persists, please contact us at {email}"
              );
            },
          },
        ]);
        showError.value = true;
      } finally {
        loading.value = false;
      }
    };

    return {
      fieldError,
      loading,
      showError,
      nextRoute,
      values,
      fields,
      valid,
      submit,
    };
  },
});
